<template>
    <v-layout row>
        <v-flex xs12 sm12>
            <v-card class="elavation-1 transparent">
                <v-toolbar class="transparent" flat height="37">
                    <v-spacer></v-spacer>
                </v-toolbar>
            </v-card>
            <app-pages :app_id="pageIds.my_attendance"></app-pages>
        </v-flex>
    </v-layout> 
</template>

<script>
import pageIds from '@/constants/app_ids'

export default {     
    name: 'PageMenu',
    metaInfo: {
        title: 'Page Menu',
        meta: [
            { charset: 'utf-8' },
            { name: 'description', content: 'Page Menu' },
            { name: 'viewport', content: 'width=device-width, initial-scale=1' }
            ]
    },
    components: {
        'app-pages': ()=> import('@/components/Common/PageMenu')
    },   
    data () {
        return {
            error: false,
            errorMessage: '',
            loading: false,
        }
    },
    async created() {
        this.pageIds = pageIds

        //update header titles
        this.$root.$emit('setHeaderTitles', {
            display: true,
            isMainMenu: true,
            headerTitle: 'My Attendance',
            headerPageTitle: 'Menu'
        })
    }
}
</script>